import React from "react";

import Navigation from "../Navigation/NavigationDesktop";
import HeaderLogo from "../HeaderLogo";
import classNames from "classnames";
import Styles from "../Header.module.scss";
// import ThemeToggle from "../../../../shared/components/ThemeToggle/ThemeToggle";

const HeaderDesktop = () => {
  return (
    <div className={classNames(Styles.headerMainContainer)} id="header-main-container">
      <HeaderLogo />
      <div className={Styles.headerContent}>
        <div className={Styles.headerNavigation}>
          <Navigation />
          {/* <ThemeToggle /> */}
        </div>
      </div>
    </div>
  );
};

export default HeaderDesktop;
